import { render, staticRenderFns } from "./search-filter-2.vue?vue&type=template&id=96db9528&scoped=true"
import script from "./search-filter-2.vue?vue&type=script&lang=js"
export * from "./search-filter-2.vue?vue&type=script&lang=js"
import style0 from "./search-filter-2.vue?vue&type=style&index=0&id=96db9528&prod&lang=css"
import style1 from "./search-filter-2.vue?vue&type=style&index=1&id=96db9528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96db9528",
  null
  
)

export default component.exports